module.exports = __webpack_public_path__ + "img/5. Contact us.0459c980.png";